export class AuthListenerEvent extends CustomEvent {
    constructor(type, options) {
        super(type, options);
    }
}
//# sourceMappingURL=auth-listener-event.entity.js.map